import React, { useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export default function RHSidebar() {
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const handleLogout = () => {
        localStorage.clear();
        toast.success('Déconnexion réussie');
        navigate('/login');
    };

    const menuItems = [
        { path: '/rh', name: '📋 Salariés', icon: '👥' },
        { path: '/tv-sahel', name: 'TV Sahel', icon: '📺' },
        { path: '/rh/bus', name: 'Gestion des bus', icon: '🚌' },
        { path: '/rh/feed', name: '✨ Fil d\'actualité', icon: '📰' },
        { path: '/rh/mes-medias', name: '📱 Mes médias', icon: '🖼️' },
        { path: '/rh/contractuels', name: '📄 Contractuels', icon: '📄' },
        { path: '/rh/primes', name: '💰 Primes', icon: '💰' },
        { path: '/rh/attribution-primes', name: '🎁 Attribuer primes', icon: '🎁' },
        { path: '/rh/supprimer-attribution', name: '🗑️ Supprimer attribution', icon: '🗑️' },
        { path: '/rh/avancement', name: '📈 Avancement', icon: '📈' },
        { path: '/rh/profil', name: '👤 Mon profil', icon: '⚙️' }
    ];

    // Menu mobile (overlay)
    const MobileMenu = () => (
        <>
            {isOpen && (
                <div 
                    className="fixed inset-0 bg-black/50 z-40 lg:hidden"
                    onClick={() => setIsOpen(false)}
                />
            )}
            <div className={`
                fixed top-0 left-0 h-full w-64 bg-gradient-to-b from-blue-800 to-blue-950 text-white z-50 
                transform transition-transform duration-300 ease-in-out lg:hidden
                ${isOpen ? 'translate-x-0' : '-translate-x-full'}
            `}>
                <div className="flex flex-col h-full">
                    <div className="flex-shrink-0 p-5 border-b border-blue-700/50">
                        <div className="flex justify-between items-center">
                            <div className="text-center flex-1">
                                <div className="w-12 h-12 bg-blue-600/30 rounded-full flex items-center justify-center mx-auto mb-2">
                                    <span className="text-2xl">🏛️</span>
                                </div>
                                <h2 className="text-lg font-bold">CROUS Niger</h2>
                                <p className="text-xs text-blue-300 mt-0.5">Espace RH</p>
                                <p className="text-xs text-blue-400/70 mt-1">{user.prenom} {user.nom}</p>
                            </div>
                            <button 
                                onClick={() => setIsOpen(false)}
                                className="text-white/70 hover:text-white text-2xl"
                            >
                                ✕
                            </button>
                        </div>
                    </div>
                    
                    <div className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
                        {menuItems.map((item) => (
                            <NavLink
                                key={item.path}
                                to={item.path}
                                onClick={() => setIsOpen(false)}
                                className={({ isActive }) =>
                                    `flex items-center gap-3 px-3 py-2 rounded-lg transition text-sm ${
                                        isActive
                                            ? 'bg-blue-600 text-white'
                                            : 'hover:bg-blue-700/50 text-blue-100'
                                    }`
                                }
                            >
                                <span className="text-lg">{item.icon}</span>
                                <span className="flex-1">{item.name}</span>
                            </NavLink>
                        ))}
                    </div>
                    
                    <div className="flex-shrink-0 p-3 border-t border-blue-700/50">
                        <button
                            onClick={() => {
                                handleLogout();
                                setIsOpen(false);
                            }}
                            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-600/30 text-blue-100 transition text-sm"
                        >
                            <span className="text-lg">🚪</span>
                            <span>Déconnexion</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    );

    // Sidebar desktop (toujours visible)
    const DesktopSidebar = () => (
        <div className="hidden lg:flex lg:flex-col lg:w-64 lg:fixed lg:left-0 lg:top-0 lg:h-full lg:bg-gradient-to-b lg:from-blue-800 lg:to-blue-950 lg:text-white lg:shadow-xl">
            <div className="flex flex-col h-full">
                <div className="flex-shrink-0 p-5 border-b border-blue-700/50">
                    <div className="text-center">
                        <div className="w-14 h-14 bg-blue-600/30 rounded-full flex items-center justify-center mx-auto mb-2">
                            <span className="text-2xl">🏛️</span>
                        </div>
                        <h2 className="text-lg font-bold">CROUS Niger</h2>
                        <p className="text-xs text-blue-300 mt-0.5">Espace RH</p>
                        <p className="text-xs text-blue-400/70 mt-1">{user.prenom} {user.nom}</p>
                    </div>
                </div>
                
                <div className="flex-1 overflow-y-auto py-3 px-3 space-y-1">
                    {menuItems.map((item) => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            className={({ isActive }) =>
                                `flex items-center gap-3 px-3 py-2 rounded-lg transition text-sm ${
                                    isActive
                                        ? 'bg-blue-600 text-white'
                                        : 'hover:bg-blue-700/50 text-blue-100'
                                }`
                            }
                        >
                            <span className="text-lg">{item.icon}</span>
                            <span className="flex-1">{item.name}</span>
                        </NavLink>
                    ))}
                </div>
                
                <div className="flex-shrink-0 p-3 border-t border-blue-700/50">
                    <button
                        onClick={handleLogout}
                        className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-600/30 text-blue-100 transition text-sm"
                    >
                        <span className="text-lg">🚪</span>
                        <span>Déconnexion</span>
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <>
            <DesktopSidebar />
            <MobileMenu />
            
            {/* Bouton hamburger pour mobile */}
            <button
                onClick={() => setIsOpen(true)}
                className="fixed top-4 left-4 z-30 lg:hidden bg-blue-600 text-white p-2 rounded-lg shadow-lg"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
            </button>
        </>
    );
}